import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	DialogContentText,
	Button,
	TextField,
} from "@mui/material";
import { standardJobDocumentTemplates } from "@/dentlab/src/pages/job-document-templates/standard-job-document-templates";
import { JobItemEntityType } from "@/lib/supabase/supabaseTypes";
import { useState } from "react";
import { showNotification } from "../../../store/Central/selectors";

export const CreateNewTemplateDialog: React.FC<{
	onCreateTemplate: (code: string, name: string, jobItems?: JobItemEntityType[]) => void;
	open: boolean;
	setOpen: (open: boolean) => void;
}> = ({ onCreateTemplate, open, setOpen }) => {
	const [code, setCode] = useState("");
	const [name, setName] = useState("");
	const [jobItems, setJobItems] = useState<JobItemEntityType[]>([]);

	const handleSelectStandardTemplate = (templateCode: string) => {
		const template = standardJobDocumentTemplates.find(t => t.code === templateCode);
		if (template) {
			setCode(template.code);
			setName(template.name);
			setJobItems(template.job_items as JobItemEntityType[]);
		}
	};

	const handleSubmit = () => {
		if (!code) {
			showNotification({
				message: "Code erforderlich",
				type: "warning",
			});
			return;
		}

		onCreateTemplate(code, name, jobItems);
		setCode("");
		setName("");
		setJobItems([]);
		setOpen(false);
	};
	
	const resetForm = () => {
		setCode("");
		setName("");
		setJobItems([]);
		setOpen(false);
	};

	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">
				{"Vorlage erstellen"}
			</DialogTitle>
			<DialogContent className="flex flex-col gap-3">
				<DialogContentText id="alert-dialog-description">
					Erstellen Sie eine neue Vorlage, um sie später wieder
					verwenden zu können.
				</DialogContentText>
        
					<div className="flex flex-col gap-0.5">
						<TextField
							id="code"
							label="Code"
							value={code}
							onChange={(e) => setCode(e.target.value)}
						/>
						<TextField
							id="name"
							label="Name"
							value={name}
							onChange={(e) => setName(e.target.value)}
						/>
					</div>
			</DialogContent>
			<DialogActions>
				<Button onClick={resetForm}>Abbrechen</Button>
				<Button onClick={handleSubmit} autoFocus>
					Erstellen
				</Button>
			</DialogActions>
		</Dialog>
	);
};
